//font: André Pantaleão
function debounce(fn, time) {
  let timer;

  return function (...args) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, time);
  };
}

export default debounce;



// WEBPACK FOOTER //
// ./src/helpers/debounce.js